// export const SIGN_UP = '/signup';
// export const SIGN_IN = '/signin';

//  I make these routes
export const HOME = "/home";
export const StaticHome = "/StaticHome";
export const StaticLogin = "/Login";
export const Introduction = "/Introduction";
export const Service = "/Service";
export const Messageforchirman = "/Messageforchirman";
export const Register = "/Register";
export const ForgotPassword = "/ForgotPassword";
export const LiveWebinar = "/LiveWebinar/:id";
export const UserView = "/Userview";
export const AssesmentCourse = "/onlineCourse";
export const CpdShortCourse = "/CpdShortCourse";
export const CpdProfile = "/CpdProfile";
export const ByeLaws = "/byelaws";
export const GuideLineMauals = "/GuideLineMauals";
export const ImportantNews = "/important-news";
export const EPE = "/EPE";
export const peb = "/peb";
export const FormDocument = "/Forms";
export const ScheduleCPDActivities = "/ScheduleCPDActivities";
export const CPDrecognition = "/CPDrecognition";
export const ProfessionalEngnrBodies = "/ProfessionalEngnrBodies";
export const ComingSoon = "/comingsoon";
export const ShortCoursesPPT = "/ShortCoursesPPT";
export const Principal = "/Principle";
export const Crieteria = "/Crieteria";
export const Procedure = "/Procedure";
export const GuidelinesCPDBodieswithPEC = "/GuidelinesCPDBodieswithPEC";
export const FeeStructureforRegistration = "/FeeStructureforRegistration";
export const WebinarSearch = "/WebinarSearch/:id";
export const DescriptionWebinar = "/DescriptionWebinar";
export const Instructorview = "/instructorview";
export const userlogs =
  "/Self_Motivation:A_Tool_to_Gain_Peak_Performance_for_Engineers";
export const webinartest = "/webinartest";
export const epdcIntro = "/epdc/intro";
export const ContactUS = "/ContactUS";
export const Album = "/Album";
export const Gallery = "/Gallery/:id";
export const Organogram = "/Organogram";
export const EPDCCompostion = "/EPDCCompostion";
export const EPECustom = "/EPECustom";
export const CalculatorofCPD = "/CalculatorofCPD";
export const EPEForms = "/EPEForms";
export const CPDForms = "/CPDForms";
export const Documents = "/Documents";
export const CPD_Resource_person = "/CPD_Resource_person";
// export const api_testing = "/api_testing";
export const PEBs_calendar_2020 = "/PEBs_calendar_2020";

export const CPDRelaxPolicy = "/CPDRelaxPolicy";
export const CPDBriefs = "/CPDBriefs";
export const CPDListofResourcePerson = "/CPDListofResourcePerson";
export const CPDResourcePersonCriteria = "/CPDResourcePersonCriteria";
export const ApplicationForm = "/ApplicationForm";

export const UserPayment = "/UserPayment";

//  Finished

export const ABOUT = "/about";
export const FAQ = "/faq";
export const COURSEDETAIL = "/viewdetail/:id";

export const COURSE = "/course"; // Render Course Component
export const PQ = "/practicequestion"; // Render Course Component
export const ME = "/mockexam"; // Render Course Component

export const PQA = "/admin/practicequestion"; // Render AdminHome Component
export const COA = "/admin/course"; // Render AdminHome Component
export const MEA = "/admin/mockexam"; // Render AdminHome Component
export const CourseEdit = "/admin/:id/:key"; // Render AdminHome Component
export const QFeedback = "/admin/feedback";
export const Coupons = "/admin/coupon";
export const ManageCT = "/admin/managect";
export const ManageSlider = "/admin/manageslider";
export const PermissionsTable = "/admin/permissions";
export const UserPermissions = "/admin/accesscontrol";
export const Assignments = "/admin/assignments";
export const Logs = "/admin/logs";
export const ManageUsers = "/admin/users";
export const ManageUsersCourse = "/admin/manageusers";
export const PracticeQuestion = "/admin/:id";

export const QuestionBank = "/admin/questionbank";
export const Addfaq = "/admin/webfaq";

export const MyCourse = "/mycourse/:id";
export const Question = "/questions";
export const AdminMockCourse = "/dashboard1";
export const QuestionForm = "/questionpool";
export const QuestionPoolList = "/questionlist";
export const Cart = "/cart";
export const Profile = "/profile/:id";
export const Chat = "/Chat";
export const adminlogin = "/admin";
export const setPassword = "/setPassword";

export const ResetPassword = "/ResetPassword/";
export const loginReset = "/loginReset";
export const adminDashboard = "/admin/dashboard/";
export const addcourse = "/admin/course/new";

export const adminSummary = "/admin/dashboard/summary";

export const setAdminPassword = "/setAdminPassword/:token";

// export const ACCOUNT = '/account';
// export const PASSWORD_FORGET = '/pw-forget';

//mubashir routes
export const ClaimCPD = "/CPD/ClaimCPD";
export const CpdFormProfile = "/CPD/CpdFormProfile";
export const CpdProfilePoints = "/CPD/CpdProfilePoints";
export const pdf = "/UserPayment/pdf";
export const DropZone = "/CPD/DropZone";
export const EngineerLogin = "/engineer/login";
export const AccessDenied = "/engineer/access-denied";
export const EngineerPayment = "/engineer/engineer-payment";
export const AdditionalChallanSubmission = "/engineer/additional-challan-submission";
export const ApplicationPreview = "/engineer/application-preview";
export const EngineerSponser = "/engineer/applicant-sponser"
export const EngineerPaymentPdf = "/engineer/engineer-payment-pdf";
export const EngineerEpeForm = "/engineer/engineer-epe-form";
export const CreateCenterForm = "/engineer/center-form";
